"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormsyInput = void 0;

var _formsyReact = require("formsy-react");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));

var _react = _interopRequireDefault(require("react"));

var _formGroup = require("../form-group");

var _theme = require("../theme");

var _utils = require("../utils");

var _index = require("../utils/index");

var _useDebouncedErrors = _interopRequireDefault(require("../utils/useDebouncedErrors"));

var _Input = _interopRequireDefault(require("./Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Formsy wrapped input. Uses FormGroup for label, hints, errors etc.
 */
const FormsyInput = props => {
  var _validations$maxLengt;

  const [formsyProps, restProps] = (0, _utils.filterFormsyProps)(props);
  const {
    name,
    value = '',
    setValue,
    validations
  } = formsyProps;
  const {
    className = '',
    description,
    label,
    onChange,
    ...inputProps
  } = restProps;
  const [useCss, theme] = (0, _theme.useStyletron)();
  const [validationErrors, updateErrors] = (0, _useDebouncedErrors.default)((0, _utils.getValidationErrorsString)(props)); // @ts-ignore

  const charsRemaining = (0, _index.getCharsRemaining)(value, // @ts-ignore
  (_validations$maxLengt = validations === null || validations === void 0 ? void 0 : validations.maxLength) !== null && _validations$maxLengt !== void 0 ? _validations$maxLengt : null);
  const charsRemainingStyle = useCss({ ...theme.typography.bodyText5,
    color: charsRemaining && charsRemaining < 0 ? theme.colors.negative : theme.colors.grey50
  }); // TODO (TA-25291): i18n

  const remainingText = !(0, _isNil.default)(charsRemaining) ? /*#__PURE__*/_react.default.createElement("span", {
    className: charsRemainingStyle
  }, charsRemaining) : null;

  function onInputChange(value) {
    updateErrors();
    setValue(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  }

  const labelId = (0, _kebabCase.default)(name);
  return /*#__PURE__*/_react.default.createElement(_formGroup.FormGroup, {
    className: className,
    label: label,
    labelId: labelId,
    feedback: remainingText,
    errors: validationErrors,
    description: description
  }, /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, inputProps, {
    "aria-labelledby": labelId,
    name: name,
    value: value,
    onChange: onInputChange,
    error: !(0, _isEmpty.default)(validationErrors)
  })));
};

exports.FormsyInput = FormsyInput;

var _default = (0, _formsyReact.withFormsy)(FormsyInput);

exports.default = _default;